import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Regular,
    H2,
    LargePrimaryButton,
    ErrorAlert,
    LargeSecondaryButton,
} from "@worthy-npm/clarity";
import ImageUploaderWrapper from "./ImageUploaderWrapper";
import { dataAutomationAttr, isMobile } from "helpers/ApplicationHelper";
import { getItem, clearItemAndCache, clearItemFromCache } from "actions/item";

import { bindActionCreators } from "redux";
import I18n from "lib/i18n/i18n";
import UserActions from "lib/userActions";
import SellItemWizard from "components/sellItemWizard";
import { browserHistory } from "react-router";

class UploadPhoto extends Component {
    constructor(props) {
        super(props);

        this.state = { hasPhoto: null, loading: false };
        const itemId = props.params ? props.params.itemId : props.item.id;
        if (!this.props.item) {
            this.props.getItem(itemId);
        }
        this.isMobile = isMobile();
    }

    componentDidMount() {
        console.timeEnd("register");
        if (this.props.item) {
            UserActions.uploadPhoto(
                "Upload photo page presented",
                this.props.item.id
            );
        }
        if (!this.state.funnelStepEventFired) {
            this.setState({ funnelStepEventFired: true });
        }
    }

    uploadStart = () => {
        this.setState({ loading: true });
    };

    onClickMe = (action) => {
        const { item, onFinish } = this.props;
        if (item) {
            const msg = `Upload photo - click ${action}`;
            UserActions.uploadPhoto(msg, item.id);
            if (item.main_item_id) {
                this.props.clearItemAndCache(item.id);
                // Forwarding back to the main item in the bundle
                browserHistory.push(`/ll/${item.main_item_id}`);
            } else {
                onFinish();
                this.props.clearItemFromCache(item);
            }
        }
    };

    render() {
        const { item } = this.props;
        const { hasPhoto, uploadFailure, loading } = this.state;

        if (!item) return <noscript />;
        // TODO: may be simplified to `props.item.photos` once API updates item in redux' store after image uploading/removing
        const hasUploadedImages =
            hasPhoto === null ? item.photos && item.photos.length : hasPhoto;
        const buttonOverride = {
            padding: "11px 22px 12px"
        };
        const widthOverride = { width: `${isMobile() ? "290px" : ""}` };
        return (
            <div id="listing-upload-photo-container">
                <SellItemWizard step={3} />
                {uploadFailure ? (
                    <div className={"image-uploader-error-container"}>
                        <ErrorAlert
                            text={I18n.getString("uploadImageFailureGeneral")}
                            onClose={() => {}}
                        />
                    </div>
                ) : null}
                <H2
                    text={I18n.getString(
                        "listingPage::listingUploadPhoto::title"
                    )}
                    overrideCSS={{
                        fontFamily: "Argesta Headline",
                        fontSize: "36px",
                        fontWeight: "400",
                    }}
                />
                <div className={"paragraph-text"}>
                    <Regular
                        text={I18n.getJsx(
                            "listingPage::listingUploadPhoto::text",
                            {
                                item_type: <span>{item.item_type}</span>,
                            }
                        )}
                        overrideCSS={{
                            fontSize: "16px",
                            lineHeight: "28px",
                        }}
                    />
                </div>
                <ImageUploaderWrapper
                    key="image-uploader-container"
                    className="listing-upload-photo"
                    item={item}
                    multiple
                    optimizedWidth={
                        300
                    } /* Reducing loading time from, thanks to Cloudinary transformations. 300px = 2 * the block width */
                    optionalText={I18n.getString(
                        "listingPage::listingUploadPhoto::optionalText"
                    )}
                    optionalSubText={I18n.getString(
                        "listingPage::listingUploadPhoto::optionalSubText"
                    )}
                    data-automation={dataAutomationAttr("image-uploader")}
                    onSuccess={() => {
                        this.setState({ hasPhoto: true, loading: false });
                    }}
                    onFailure={() =>
                        this.setState({ uploadFailure: true, loading: false })
                    }
                    onBeforeUpload={this.uploadStart}
                    showImages={true}
                    onRemoveAll={() => this.setState({ hasPhoto: false })}
                />
                {hasUploadedImages ? (
                    <div
                        className={"continue-button-wrapper"}
                        data-automation={dataAutomationAttr(
                            "continue-uploadPhoto"
                        )}
                    >
                        <LargePrimaryButton
                            click={() => this.onClickMe("continue")}
                            text={I18n.getString(
                                "listingPage::listingUploadPhoto::continue"
                            )}
                            overrideCSS={{
                                ...buttonOverride,
                                ...widthOverride,
                            }}
                        />
                    </div>
                ) : !item.estimation?.is_photo_mandatory || item.premium_brand ? (
                    <div
                        className={`skip-button-wrapper ${
                            loading ? "hide" : ""
                        }`}
                        data-automation={dataAutomationAttr("skip-uploadPhoto")}
                    >
                        <LargeSecondaryButton
                            text={I18n.getString(
                                "listingPage::listingUploadPhoto::skip"
                            )}
                            click={() => this.onClickMe("skip")}
                            overrideCSS={buttonOverride}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { getItem, clearItemAndCache, clearItemFromCache },
        dispatch
    );
};

const mapStateToProps = ({ Item }) => {
    return {
        item: Item,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadPhoto);
